import { render } from "./set-screen-saver.vue?vue&type=template&id=68c3c33e&scoped=true&ts=true"
import script from "./set-screen-saver.vue?vue&type=script&lang=ts"
export * from "./set-screen-saver.vue?vue&type=script&lang=ts"

import "./set-screen-saver.vue?vue&type=style&index=0&id=68c3c33e&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c3c33e"]])

export default __exports__